module.exports = __webpack_public_path__ + "img/img_product_04@2x.bed5b59b.png";